import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_auth/auth-redirect')({
  component: RouteComponent,
  validateSearch: (search) => search,
});

function RouteComponent() {
  return <div></div>;
}
